import { useEffect, useRef, useState } from 'react';
import { isDark, setTheme, THEMES, useTheme, type Theme } from '../lib/theme';
import { Icon } from './Icon';
import './theme-menu.css';

/** The theme button: a menu of System, Light, Dark and Graphite, the current one ticked. */
export function ThemeToggle({ className = 'btn ghost icon' }: { className?: string }) {
  const { pref, theme } = useTheme();
  const [open, setOpen] = useState(false);
  const box = useRef<HTMLSpanElement>(null);
  useEffect(() => {
    if (!open) return;
    const down = (e: MouseEvent) => { if (!box.current?.contains(e.target as Node)) setOpen(false); };
    const esc = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', down);
    window.addEventListener('keydown', esc);
    return () => { document.removeEventListener('mousedown', down); window.removeEventListener('keydown', esc); };
  }, [open]);
  return (
    <span className="theme-menu" ref={box}>
      <button type="button" className={className} title="Theme" aria-label="Theme" aria-expanded={open} onClick={() => setOpen(!open)}>
        <Icon name={isDark(theme) ? 'moon' : 'sun'} size={16} />
      </button>
      {open && (
        <span className="theme-pop" role="menu">
          {THEMES.map((t) => (
            <button key={t.id} type="button" role="menuitemradio" aria-checked={pref === t.id}
                    onClick={() => { setTheme(t.id); setOpen(false); }}>
              <span className={'theme-sw ' + t.id} aria-hidden="true" />
              {t.label}
              {pref === t.id && <Icon name="check" size={14} className="ico tick" />}
            </button>
          ))}
        </span>
      )}
    </span>
  );
}

/** The logo with light letters on the dark themes. */
export function logoSrc(theme: Theme) {
  return isDark(theme) ? '/logo-dark.png' : '/logo.png';
}
